"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/* [DISABLED_TEMPORARILY] @ typescript-eslint /camelcase */
var bannerSliderConfig = [
    // Increasing max number of banners limit from 4 to 12
    {
        key: 'textColor',
        type: 'color',
        label_ar: 'CTA Text Color',
        label_en: 'CTA Text Color',
        required: false,
        sort: 5,
    },
    {
        key: 'banners',
        type: 'array',
        label_ar: 'Banner',
        label_en: 'Banner',
        required: true,
        sort: 2,
        values: [
            {
                // key: 'imageUrl',
                key: 'imagePath',
                type: 'image',
                max_width: 1440,
                label_ar: 'Image',
                label_en: 'Image',
                description_en: 'Recommended Size:<br/>Single Banner (Desktop) - 1440x250<br/>Single Banner (Mobile) - 800x250',
                description_ar: 'Recommended Size:<br/>Single Banner (Desktop) - 1440x250<br/>Single Banner (Mobile) - 800x250',
                required: true,
                sort: 1,
            },
            {
                key: 'linkUrl',
                type: 'url',
                label_ar: 'Link Url',
                label_en: 'Link Url',
                description_en: 'The URL may look more generic after saving, but it will point to the same page',
                description_ar: 'The URL may look more generic after saving, but it will point to the same page',
                required: false,
                sort: 2,
            },
            // {
            //     type: 'exclusive_group',
            //     required: true,
            //     label_ar: 'Media Type',
            //     label_en: 'Media Type',
            //     default_value: 'image',
            //     groups: [
            //         {
            //             group_key: 'image',
            //             label_ar: 'Image',
            //             label_en: 'Image',
            //         },
            //         {
            //             group_key: 'video',
            //             label_ar: 'Video',
            //             label_en: 'Video',
            //         },
            //     ],
            //     settings: [
            //         {
            //             group_key: 'image',
            //             key: 'imageUrl',
            //             type: 'image',
            //             label_ar: 'Image',
            //             label_en: 'Image',
            //             required: true,
            //         },
            //         {
            //             group_key: 'image',
            //             key: 'linkUrl',
            //             type: 'url',
            //             label_ar: 'Link Url',
            //             label_en: 'Link Url',
            //             required: false,
            //         },
            //         {
            //             group_key: 'video',
            //             key: 'videoUrl',
            //             type: 'video',
            //             label_ar: 'Video',
            //             label_en: 'Video',
            //             required: true,
            //         },
            //         {
            //             group_key: 'video',
            //             key: 'videoControls',
            //             type: 'boolean',
            //             label_ar: 'Video Controls',
            //             label_en: 'Video Controls',
            //             required: false,
            //         },
            //     ],
            // },
            {
                key: 'titleText',
                type: 'string',
                label_ar: 'Title Text',
                label_en: 'Title Text',
                required: false,
                sort: 3,
            },
            {
                key: 'summaryText',
                type: 'string',
                label_ar: 'Subtitle Text',
                label_en: 'Subtitle Text',
                required: false,
                sort: 4,
            },
            // Virtual - No use for this yet as not looking into analysis
            {
                key: 'assetId',
                type: 'number',
                label_ar: 'Asset ID',
                label_en: 'Asset ID',
                required: false,
                is_virtual: true,
            },
            // Virtual since it is calculated behind the scenes of CMS
            {
                key: 'ratio',
                type: 'number',
                label_ar: 'Ratio',
                label_en: 'Ratio',
                required: false,
                is_virtual: true,
            },
            // Virtual for time being. Already have title and subtitle
            {
                key: 'ctaText',
                type: 'string',
                label_ar: 'CTA Text',
                label_en: 'CTA Text',
                required: false,
                is_virtual: true,
            },
            // No CTA Url ??
            // Virtual for time being. Already have title and subtitle
            {
                key: 'ctaColor',
                type: 'color',
                label_ar: 'CTA Text Color',
                label_en: 'CTA Text Color',
                required: false,
                is_virtual: true,
            },
            // Virtual for time being. Already have title and subtitle
            {
                key: 'ctaBgColor',
                type: 'color',
                label_ar: 'CTA Background Color',
                label_en: 'CTA Background Color',
                required: false,
                is_virtual: true,
            },
            // Virtual for time being. Complicated stuff
            {
                key: 'videoRatio',
                type: 'video',
                label_ar: 'Video Ratio',
                label_en: 'Video Ratio',
                required: false,
                is_virtual: true,
            },
            // Virtual since this property is calculated automatically in widgets package
            {
                key: 'externalLink',
                type: 'boolean',
                label_ar: 'External Link',
                label_en: 'External Link',
                required: false,
                is_virtual: true,
            },
            // Virtual since looks very plain, color not configurable
            // and Noon team has used it very little
            {
                key: 'supportLinks',
                type: 'array',
                label_ar: 'Support Link',
                label_en: 'Support Link',
                required: false,
                is_virtual: true,
                values: [
                    {
                        key: 'linkText',
                        type: 'string',
                        label_ar: 'Link Text',
                        label_en: 'Link Text',
                        required: true,
                    },
                    {
                        key: 'linkUrl',
                        type: 'url',
                        label_ar: 'Link Url',
                        label_en: 'Link Url',
                        required: false,
                    },
                    {
                        key: 'emphasis',
                        type: 'boolean',
                        label_ar: 'Emphasis',
                        label_en: 'Emphasis',
                        required: false,
                    },
                ],
            },
            // Virtual as no use for this yet as not looking into analysis
            {
                key: 'gapt',
                type: 'group',
                label_ar: 'Gapt',
                label_en: 'Gapt',
                required: false,
                is_virtual: true,
                values: [
                    {
                        key: 'name',
                        type: 'string',
                        label_ar: 'Name',
                        label_en: 'Name',
                        required: true,
                    },
                    {
                        key: 'position',
                        type: 'string',
                        label_ar: 'Position',
                        label_en: 'Position',
                        required: true,
                    },
                ],
            },
        ],
    },
    {
        key: 'moduleHeader',
        type: 'group',
        label_ar: 'Module Header',
        label_en: 'Module Header',
        required: false,
        sort: 4,
        values: [
            {
                key: 'titleText',
                type: 'string',
                label_ar: 'Title Text',
                label_en: 'Title Text',
                required: false,
                sort: 1,
            },
            {
                key: 'titleColor',
                type: 'color',
                label_ar: 'Title Text Color',
                label_en: 'Title Text Color',
                required: false,
                sort: 2,
            },
            {
                key: 'linkText',
                type: 'string',
                label_ar: 'CTA Text',
                label_en: 'CTA Text',
                required: false,
                sort: 3,
            },
            {
                key: 'linkUrl',
                type: 'url',
                label_ar: 'CTA Url',
                label_en: 'CTA Url',
                required: false,
                sort: 4,
            },
            // TODO - why does this not work
            {
                key: 'textColor',
                type: 'color',
                label_ar: 'CTA Text Color',
                label_en: 'CTA Text Color',
                required: false,
                sort: 5,
            },
            {
                key: 'linkBgColor',
                type: 'color',
                label_ar: 'CTA Background Color',
                label_en: 'CTA Background Color',
                required: false,
                sort: 6,
            },
            // Not including this, do not like image in header
            // Just make another banner widget
            {
                key: 'titleImageUrl',
                type: 'image',
                label_ar: 'Title Image',
                label_en: 'Title Image',
                required: false,
                is_virtual: true,
            },
        ],
    },
    // Virtual as no use for this yet as not looking into analysis
    {
        key: 'widgetId',
        type: 'number',
        label_ar: 'Widget ID',
        label_en: 'Widget ID',
        required: false,
        is_virtual: true,
    },
];
exports.default = bannerSliderConfig;
//# sourceMappingURL=config.js.map